<template>
  <div>
    <a href="https://www.biopama.org/"> <span class="popup-close">+</span> </a>
    <div class="left-panel">
      <div class="left-inner">
        <div class="language-switch-container">
          <locale-switch></locale-switch>
        </div>
        <div class="lp-signup">
          <p>{{ $t('auth.login__top_line') }}</p>
          <router-link to="/auth/register" class="btn btn-primary btn-simple">{{ $t('auth.btn_signup') }}</router-link>
        </div>

        <h1>{{ $t('auth.login__title') }}</h1>
        <h3>{{ $t('auth.login__subtitle') }}</h3>

        <form @submit.prevent="submitLogin">
          <div>
            <div v-if="submitted && !authenticating && authenticationError" class="mb-3 error-login has-danger">
              {{getAuthenticationError}}
            </div>

            <span class="lp-form-input">
            <input type="text"
                   v-validate="'required|email'"
                   name="email"
                   :error="getError('email')"
                   v-model="model.email"
                   id="email"
            />
            <label for="email">{{ $t('auth.input_email') }}</label>
            <span v-if="getError('email')" class="has-error">{{ getError('email') }}</span>
            </span>

            <span class="lp-form-input">
            <input type="password"
                   v-validate="'required'"
                   name="password"
                   :error="getError('password')"
                   v-model="model.password"
                   id="password"
            />
            <label for="password">{{ $t('auth.input_password') }}</label>
              <router-link to="/auth/forgot">{{ $t('auth.forgot_password') }}</router-link>
              <span v-if="getError('password')" class="has-error">{{ getError('password') }}</span>
          </span>
          </div>

          <div slot="footer">
            <button class="btn btn-lg btn-primary submit-button" :class="{'disabled': loading}" :disabled="loading" type="submit">{{ $t('auth.btn_login') }}</button>
          </div>
        </form>
      </div>
    </div>
    <div class="right-panel">
      <canvas class="strength-indicator" width="628" height="679"></canvas>
    </div>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import {PasswordStrengthInit} from "@/helpers/PasswordStrength.js";
  import LocaleSwitch from "@/components/LocaleSwitch";

  export default {
    data() {
      return {
        loading: false,
        submitted: false,
        model: {
          email: '',
          password: ''
        }
      };
    },
    components: {
      LocaleSwitch
    },
    computed: {
      ...mapGetters('Auth', [
        'authenticating',
        'authenticationError'
      ]),
      getAuthenticationError: function () {
        return this.$t('auth.login__' + this.authenticationError);
      },
    },

    methods: {
      async submitLogin() {
        let isValidForm = await this.$validator.validateAll();
        if (isValidForm) {
          this.loading = true;

          await this.$store.dispatch('Auth/login', {
            email: this.model.email,
            password: this.model.password
          });

          this.loading = false;
          this.submitted = true;
        }
      },
      getError: function (fieldName) {
        return this.errors.first(fieldName);
      }
    },
    mounted() {
      PasswordStrengthInit();
    }
  };
</script>

<style lang="scss">
  .full-page .content .lp-form-input input {
    padding-bottom: 0.5vh;
  }

  .error-login {
    padding-left: 0.75rem;
  }

  .has-danger {
    color: $danger;
  }
</style>